
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-web-administracion/pc/publicaciones/controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Eventos.push( this.Buscador.onActualizar.subscribe( this.Iniciar ) );
        }


        Bloqueado: boolean = true;
        Pagina: number = -1;
        @Watch( 'Pagina' )
        onPagina()
        {
            if ( this.Buscador.Paginacion )
            {
                if ( this.Pagina != this.Buscador.Paginacion.Pagina )
                {
                    this.Bloqueado = true;
                    this.Buscador.Buscar( this.Pagina );
                }

            }

        }

        Iniciar()
        {
            if ( this.Estado == 'ok' )
            {
                this.Pagina = this.Buscador.Paginacion.Pagina;
                this.Bloqueado = false;
            }

        }
    }
